import documentoService from '@/service/GsDialogo/publicacion'

export default {
    'PUBLICACION_LIST': ({commit}) => {
        console.info(commit)
        return new Promise((resolve, reject) => {
            documentoService.findall().then(res => {
                resolve(res);
            }).catch(err => {
                reject(err);
            })
        });
    },
    'PUBLICACION_SAVE': ({commit},params) => {
        console.info(commit)
        return new Promise((resolve, reject) => {
            documentoService.save(params).then(res => {
                resolve(res);
            }).catch(err => {
                reject(err);
            })
        });
    },
    'PUBLICACION_UPDATE': ({commit},params) => {
        console.info(commit)
        return new Promise((resolve, reject) => {
            documentoService.update(params).then(res => {
                resolve(res);
            }).catch(err => {
                reject(err);
            })
        });
    },
    'PUBLICACION_DELETE': ({commit},params) => {
        console.info(commit)
        return new Promise((resolve, reject) => {
            documentoService.delete(params).then(res => {
                resolve(res);
            }).catch(err => {
                reject(err);
            })
        });
    }
    
}